export default "__VITE_ASSET__BPBpWXxu__"